import Vue from "vue";
import Vuex, { Store } from "vuex";
import VueRouter from "vue-router";
//import Home from '../views/Home.vue'
var firebase = require("firebase/app");

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "proposals",
    component: () =>
      import(/* webpackChunkName: "proposals" */ "../views/Proposals.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/newOrder",
    name: "newOrder",
    component: () =>
      import(
        /* webpackChunkName: "newOrder" */ "../components/proposalSteps/NewOrder.vue"
      ),
    meta: { requiresAuth: true },
  },
  {
    path: "/participants",
    name: "participants",
    component: () =>
      import(
        /* webpackChunkName: "participants" */ "../components/proposalSteps/FirstStep.vue"
      ),
    meta: { requiresAuth: true },
  },
  {
    path: "/proposalInformations",
    name: "proposalInformations",
    component: () =>
      import(
        /* webpackChunkName: "proposalInformations" */ "../components/proposalSteps/SecondStep.vue"
      ),
    meta: { requiresAuth: true },
  },
  {
    path: "/editProposal/:id",
    name: "editProposal",
    component: () =>
      import(
        /* webpackChunkName: "editProposal" */ "../views/EditProposal.vue"
      ),
    meta: { requiresAuth: true },
  },
  {
    path: "/documentations",
    name: "documentations",
    component: () =>
      import(
        /* webpackChunkName: "documentations" */ "../components/proposalSteps/ThirdStep.vue"
      ),
    meta: { requiresAuth: true },
  },
  {
    path: "/login",
    name: "login",
    component: () =>
      import(/* webpackChunkName: "login" */ "../views/Login2.vue"),
  },
  {
    path: "/register",
    name: "register",
    component: () =>
      import(/* webpackChunkName: "register" */ "../views/Register2.vue"),
  },
  {
    path: "/auth/action/:email",
    name: "email",
    component: () =>
      import(/* webpackChunkName: "Email" */ "../views/Email.vue"),
  },
  {
    path: "/sucesso",
    name: "Sucesso",
    component: () =>
      import(/* webpackChunkName: "register" */ "../views/Sucesso.vue"),
  },
  {
    path: "/usersListControl",
    name: "usersListControl",
    component: () =>
      import(
        /* webpackChunkName: "userListControl" */ "../views/UsersListControl.vue"
      ),
    meta: { requiresAuth: true },
  },
  {
    path: "/profile/team",
    name: "team",
    component: () =>
      import(/* webpackChunkName: "team" */ "../views/profile/team.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/profile/articles",
    name: "Articles",
    component: () =>
      import(
        /* webpackChunkName: "Articles" */ "../views/profile/articles.vue"
      ),
    meta: { requiresAuth: true },
  },
  {
    path: "/profile/articles/add-post",
    name: "addPost",
    component: () =>
      import(
        /* webpackChunkName: "add article" */ "../views/profile/addPost.vue"
      ),
    meta: { requiresAuth: true },
  },
  {
    path: "/profile/articles/edit-post/:id/",
    name: "EditPost",
    component: () =>
      import(
        /* webpackChunkName: "add article" */ "../views/profile/EditPost.vue"
      ),
    meta: { requiresAuth: true },
  },
  {
    path: "/fgtsDemand",
    name: "fgtsDemand",
    component: () =>
      import(/* webpackChunkName: "fgtsDemand" */ "../views/FgtsDemand.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/dashboard",
    name: "dashboard",
    component: () =>
      import(/* webpackChunkName: "dashboard" */ "../views/Dashboard.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/checklistManager",
    name: "ChecklistManager",
    component: () =>
      import(
        /* webpackChunkName: "checklistManager" */ "../views/ChecklistManager.vue"
      ),
    meta: { requiresAuth: true },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  const routeSafed = to.matched.some((record) => record.meta.requiresAuth);
  const user = firebase.auth().currentUser;
  // console.log(user);

  if (routeSafed === true && user === null) {
    next({ name: "login" });
  } else {
    localStorage.setItem("previousRoute", JSON.stringify(from.fullPath));
    next();
  }
});

export default router;
